import { Home, Cpu, Lightbulb, FileText, User } from 'lucide-react';

/**
 * App bottom nav — 5 belangrijkste opties op mobiel.
 * Iter 78 (Feb 2026): Overzicht / Apparaten / Advies / Offertes / Account.
 */
const ITEMS = [
  { id: 'home',      label: 'Overzicht', Icon: Home },
  { id: 'apparaten', label: 'Apparaten', Icon: Cpu },
  { id: 'advies',    label: 'Advies',    Icon: Lightbulb },
  { id: 'offertes',  label: 'Offertes',  Icon: FileText },
  { id: 'account',   label: 'Account',   Icon: User },
];

export const APP_TABS = ITEMS;

export default function AppBottomNav({ tab, onChange }) {
  return (
    <nav
      data-testid="app-bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0e1b16]/95 backdrop-blur-md border-t border-white/10
                 pb-[env(safe-area-inset-bottom,0)]"
    >
      <div className="grid grid-cols-5">
        {ITEMS.map(({ id, label, Icon }) => {
          const active = tab === id;
          return (
            <button
              key={id}
              onClick={() => onChange(id)}
              data-testid={`app-bottom-nav-${id}`}
              className={`flex flex-col items-center justify-center py-2.5 gap-0.5
                          transition-colors ${active ? 'text-emerald-300' : 'text-white/55 hover:text-white/80'}`}
            >
              <Icon className={`w-5 h-5 ${active ? 'stroke-[2.4]' : ''}`} />
              <span className="text-[10px] leading-none">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
